<div id="not-loggedin" class="main-container futr-theme">
    <div class="fluid-container " style="padding:0">
      <router-outlet name="master"></router-outlet>
    </div>
</div>
